import React from "react";
import Buttons from "../../../admin/careerCounciling/psychometric/Buttons";
import { Link } from "react-router-dom";
import aboutImage from "../../../../assets/AboutImage.png";
import "./psychometric.css";
// AboutImage.png
function About() {
  return (
    <div className="psych-page">
      {/* Floating particles */}
      <div className="psych-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      <div className="psych-about">
        <div className="psych-about-content">
          {/* AI Badge */}
          <div className="ai-badge" style={{ marginBottom: "1rem" }}>
            <span className="ai-dot"></span>
            AI-Powered SWOT Analysis
          </div>

          <h1>About the SWOT Test</h1>
          <p>
            Our psychometric tests are designed to help you understand yourself
            better. The test asks questions about your skills and interests based
            on{" "}
            <strong style={{ color: "#fff" }}>SWOT (Strengths, Weaknesses, Opportunities, Threats)</strong>{" "}
            Analysis.
          </p>
          <p>
            There are no right or wrong answers—just be honest! These tests
            provide insights into different aspects of yourself, helping you
            explore potential career paths based on your unique traits and
            preferences.
          </p>

          <div className="psych-info-card">
            <ul>
              <li>This Questionnaire contains 19 Questions</li>
              <li>You will need approximately 15 Minutes to complete</li>
              <li>
                <strong>
                  Please answer honestly as possible. There are no Correct or
                  Wrong Answers
                </strong>
              </li>
            </ul>
          </div>

          <Link to="/psychometric/Questions" style={{ textDecoration: "none" }}>
            <Buttons text="Begin Assessment" />
          </Link>
        </div>

        <div className="psych-about-image">
          <img src={aboutImage} alt="AboutImage" />
        </div>
      </div>
    </div>
  );
}

export default About;
